/**
 * Internal dependencies
 */
import './style.scss';
import './view-transitions.scss';
export { init, initSinglePage } from './components/app';
export { store } from './store';
